import React, { useState } from 'react';
import { Box, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';
import _ from 'lodash';
import AppLink from '../components/common/AppLink/AppLink';
import StickyTableHeader from '../components/common/StickyTableHeader';
import ListHeader from '../components/listHeader/ListHeader';
import FilterSidebar from '../components/common/filters/FilterSidebar';
import ListBottomBar from '../components/common/ListBottomBar/ListBottomBar';
import { useSearchTerm } from '../hooks/useSearchTerm';
import { useSyncPageParams } from '../hooks/useSyncPageParams';
import { useClampPage } from '../hooks/useClampPage';
import { useGetAllContactTemplates } from '../services/react-query/contact_templates';
import {
  defaultContainerStyling,
  listPageLayoutStyles,
  listPageTableRowStyling,
  listPageTableWrapperStyles,
} from '../styles/sxStyling';
import { Loading } from '../uikit';
import { UserConfigurableModule } from '../types/User';
import { FilterState, IFilter } from '../components/common/filters/interfaces';
import { archiveFilter } from '../components/common/filters/consts';
import { ROUTE_PATHS } from '../routes/Routes';
import PreferencesPopover from '../components/common/popover/PreferencesPopover';

export default function ContactTemplatesList() {
  const { currentPage, setCurrentPage } = useSyncPageParams();
  const [filterState, setFilterState] = useState<FilterState>(undefined);

  const { data, isLoading } = useGetAllContactTemplates({
    params: {
      page: currentPage,
      search: useSearchTerm(),
      filters: filterState,
    },
    enabled: true,
  });

  useClampPage(currentPage, data?.meta?.total_pages, setCurrentPage);

  if (isLoading) return <Loading />;

  const templates = data?.data || [];
  const meta = data?.meta;

  const moduleFilters: IFilter[] = [archiveFilter];
  const headerCells = ['Name', 'Title', 'Roles', 'Fields'];

  const tableRows = _.map(templates, (template) => (
    <TableRow key={template.uuid} sx={{ ...listPageTableRowStyling }}>
      <TableCell>
        <AppLink to={`/${ROUTE_PATHS.CONTACT_TEMPLATES}/${template.uuid}`}>{template.name}</AppLink>
      </TableCell>
      <TableCell>{template.contact_title_value}</TableCell>
      <TableCell>
        <PreferencesPopover values={template.roles_values || []} />
      </TableCell>
      <TableCell>{template.fields?.length || 0}</TableCell>
    </TableRow>
  ));

  return (
    <Box>
      <ListHeader title="Contact Templates" />

      <Box sx={listPageLayoutStyles}>
        <FilterSidebar
          moduleFilters={moduleFilters}
          module={UserConfigurableModule.CONTACT_TEMPLATES}
          activeFilter={filterState}
          setActiveFilter={setFilterState}
        />

        <Box sx={listPageTableWrapperStyles}>
          <TableContainer sx={defaultContainerStyling}>
            <Table>
              <StickyTableHeader cells={headerCells} />

              <TableBody>{tableRows}</TableBody>
            </Table>
          </TableContainer>

          <ListBottomBar page={currentPage} meta={meta} onChange={(_e, v) => setCurrentPage(v)} />
        </Box>
      </Box>
    </Box>
  );
}
